import { useState, useRef, useEffect, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import WriteFrameContent from "./area/write";
import MyScreenFunc from '@/pcomponents/common/screen/func/screen_func';
import { useSelector, useDispatch } from 'react-redux';
import SearchArea from "./area/search";

function CoreListArea() {
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const listAggridRef = useRef<any>(null);
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    "s_category_seq": "",
    "s_subject":"",
    "s_title_like":"",
    "s_open_group":"",
    "s_textbook_in_now_period":"",
    "s_textbook_default_one":"1",
    "select_seq": "",
    "s_addon_title_img": "1",
    "s_addon_category": "1",
    "s_addon_section": "1",
    "s_addon_video": "1",
    "s_addon_use_stu": "1",
    "s_addon_use_stu_s_mcomp_seq": "",
    "s_addon_request": "1",
    "s_addon_request_s_mcomp_seq": "",
  });
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [categoryInfoArr, setCategoryInfoArr] = useState([]);
  const WriteFrameContentRef = useRef<any>(null);
  let is_under_width = MyScreenFunc.get_is_under();

  useEffect(() => {
    list_category();
    list({});
  }, [user.comp_seq]);

  const list = (inOptObj: any) => {
    let change_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    change_list_opt["sc"] = listAggridRef.current.getListSc();
    setListOpt(change_list_opt);

    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }

    change_list_opt.s_addon_use_stu_s_mcomp_seq = user.comp_seq;
    change_list_opt.s_addon_request_s_mcomp_seq = user.comp_seq;
    if(change_list_opt.s_open_group=="main"){
      change_list_opt.s_mcomp_seq='';
    }else{
      change_list_opt.s_mcomp_seq=user.comp_seq;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/video/corse/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if(listAggridRef.current){
            listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }

          //선택
          if (change_list_opt.select_seq != "") {
            for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
              let info = response.data["data"]["info_arr"][i];
              if (info["row_pri_val"] == change_list_opt.select_seq) {
                WriteFrameContentRef.current.setInitData({
                  row_data: info,
                  isUpdate: true,
                });
              }
            }
            setTimeout(() => {
              let listNodes = listAggridRef.current.getNodeRows();
              for (let i = 0; i < listNodes.length; i++) {
                let node = listNodes[i];
                if (node.data["row_pri_val"] == change_list_opt.select_seq) {
                  listNodes[i].setSelected(true);
                }
              }
            }, 100);

          }

        } else {

        }
      });
  };

  const list_category = () => {
    let category_form_json = {
      "s_mcomp_seq": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    if (strFunc.is_empty(category_form_json.s_mcomp_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/video/category/list', category_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setCategoryInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const goDelete = () => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let del_form_data = {
      "data_arr": selected_row
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/video/corse/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          setWriteState();
        } else {
          alert(response.data["msg"]);
          list({});
        }
      });
  }

  const setWriteState = () => {
    listAggridRef.current.setSelectFalseAll();
    if (WriteFrameContentRef.current) {
      WriteFrameContentRef.current.setInitData();
    }
  };

  const cellClickedListener = useCallback((params: any) => {
    var key = params.colDef.field;
    if (key == "a_user_name" || key == "a_user_id") {
      //openOnePopup("view",true);
    }
    if (WriteFrameContentRef.current) {
      WriteFrameContentRef.current.setInitData({
        row_data: params.data,
        isUpdate: true,
      });
    }
  }, []);

  const cellRenderer = useCallback((params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;

    if (key == "row_view_section") {
      let section_num = 0;
      let video_num = 0;
      if (params.data.section_arr) {
        section_num = params.data.section_arr.length;
      }
      if (params.data.video_arr) {
        video_num = params.data.video_arr.length;
      }
      render_str = section_num + "/" + video_num;
    } else if (key == "row_view_stu_cnt") {
      if (params.data.use_stu_arr) {
        render_str = params.data.use_stu_arr.length;
      }
    } else if (key == "row_view_request") {
      if (params.data.request_arr) {
        render_str = params.data.request_arr.length;
      }
    }

    return render_str;
  }, []);

  return (
    <div>
      <div className="con_wrap">
        <table style={{ width: "100%" }}>
          <colgroup>
            <col width={"20%"} />
            <col width={"*"} />
          </colgroup>
          <tbody>
            <tr>
              <td style={{ verticalAlign: "top" }}>
                <div style={{ minWidth:560 }} >
                  <SearchArea
                    listOpt={listOpt}
                    list={list}
                    categoryInfoArr={categoryInfoArr}
                    setWriteState={setWriteState}
                    goDelete={goDelete}
                  ></SearchArea>
                  <ListAggrid
                    ref={listAggridRef}
                    infoArr={infoArr}
                    xColumnArr={{ ...xColumnArr }}
                    list={list}
                    gridOpt={{
                      fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
                      is_idx_num: true,
                      is_add_checkbox: true,
                      floatingFilter: false,
                      rowMultiSelectWithClick: false,
                      onGridReady: () => {
                        
                      },
                      onCellClicked: cellClickedListener,
                      cellRenderer: cellRenderer,
                    }}
                  ></ListAggrid>
                  <Paging now_page={listOpt.now_page}
                    num_per_page={listOpt.num_per_page}
                    total_rec={countInfo.tot}
                    is_view_num_per_page={true}
                    onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
                    onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
                </div>
              </td>
              <td style={{ verticalAlign: "top", paddingLeft: 10 }}>
                <div style={{ minWidth: 400 }} >
                  <WriteFrameContent
                    ref={WriteFrameContentRef}
                    list={(listOpt: any) => { list(listOpt); }}
                  ></WriteFrameContent>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CoreListArea;